import upperFirst from 'lodash-es/upperFirst'

export default function getHocName(hocComponentName, Wrapped) {
    const wrappedComponentName = Wrapped.displayName || Wrapped.name || 'Component'
    return `${upperFirst(hocComponentName)}(${wrappedComponentName})`
}